export const isTokenExpired = (proxyClickLogin: any) => {
  return (
    !!proxyClickLogin.tokenExpiresAt &&
    new Date(proxyClickLogin.tokenExpiresAt) <= new Date()
  );
};
